import type React from 'react';

import type { ColorName } from 'styles/config/colors';

import * as Icons from '../Icons';
import { IconSize } from '../Icons/BaseIcon';
import * as Styled from './IconFrame.styled';

export interface IconFrameProps {
  type: keyof typeof Icons;
  color?: ColorName;
  backgroundColor?: ColorName;
  size?: keyof typeof IconSize;
}

const IconFrame: React.FC<IconFrameProps> = ({
  type,
  backgroundColor,
  color,
  size = 'xl',
}) => {
  const IconComponent = Icons[type] as React.ComponentType<{
    size?: keyof typeof IconSize;
  }>;
  return (
    <Styled.IconFrame
      backgroundColor={backgroundColor}
      color={color}
      height={IconSize[size]}
      width={IconSize[size]}
    >
      <IconComponent size={size} />
    </Styled.IconFrame>
  );
};

export default IconFrame;
